import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const HIGH_SAMPLE_ROUTE_REGEXES = [
  /^\/lojas-e-usuarios\/[^/]+\/usuarios\/criar$/,
  /^\/lojas-e-usuarios\/usuarios\/[^/]+\/atualizar$/,
  /^\/lojas-e-usuarios\/lojas\/[^/]+\/atualizar$/,
];

const isHighSampledRoute = (pathname) => {
  if (!pathname) {
    return false;
  }

  if (pathname === "/contratar" || pathname.startsWith("/contratar/")) {
    return true;
  }

  if (
    pathname === "/higienizacao-de-cpfs" ||
    pathname === "/higienizacao-de-cpfs/novo" ||
    pathname === "/lojas-e-usuarios/lojas/criar"
  ) {
    return true;
  }

  return HIGH_SAMPLE_ROUTE_REGEXES.some((regex) => regex.test(pathname));
};

const shouldSendNonErrorEvent = () => Math.random() < 0.1;

process.env.NODE_ENV === "production" &&
  Sentry.init({
    dsn: "https://935ff51c6c7d040adaac650572f6be30@o4507211124637696.ingest.us.sentry.io/4508608061308928",
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],

    // Control transaction sampling based on the current route.
    tracesSampler(samplingContext) {
      const pathname = samplingContext.location?.pathname;
      const transactionName = samplingContext.transactionContext?.name;
      const fallbackPath = transactionName?.startsWith("/")
        ? transactionName
        : "";
      const pathForMatch = pathname || fallbackPath;

      return isHighSampledRoute(pathForMatch) ? 1.0 : 0.1;
    },

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["https://loan-service.ta-quitado.com"],

    // No replays
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    beforeSend(event) {
      const isErrorEvent =
        event.level === "error" ||
        event.level === "fatal" ||
        (event.exception && event.exception.values?.length > 0);

      if (isErrorEvent) {
        return event;
      }

      return shouldSendNonErrorEvent() ? event : null;
    },
  });
